import React, { Component } from "react";
import Button from "../../utils/Buttons";
import { withRouter } from "../../utils/withRouter";
class StaffForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      formData: {
        fullName: "",
        email: "",
        clinics: "",
        gender: "MALE",
        role: "STAFF",
        status: "ACTIVE",
        mobileCountryCode: "+91",
        ...(props.initialData || {}),
      },
      errors: {},
    };
  }
  componentDidMount() {
    if (this.props.initialData) {
      this.fillForm(this.props.initialData);
    }
  }
  componentDidUpdate(prevProps) {
    if (
      this.props.initialData &&
      prevProps.initialData !== this.props.initialData
    ) {
      this.fillForm(this.props.initialData);
    }
  }
  fillForm = (data) => {
    this.setState((prevState) => ({
      formData: {
        ...prevState.formData,
        ...data,
        clinics: data?.clinics?._id || data?.clinics || "",
      },
    }));
  };
  handleChange = (e) => {
    const { name, value } = e.target;
    this.setState((prevState) => ({
      formData: {
        ...prevState.formData,
        [name]: value,
      },
      errors: {
        ...prevState.errors,
        [name]: "",
      },
    }));
  };
  validate = () => {
    const { formData } = this.state;
    const errors = {};
    if (!formData.fullName?.trim()) {
      errors.fullName = "Full name is required";
    }
    if (!formData.email?.trim()) {
      errors.email = "Email is required";
    } else if (!/^\S+@\S+\.\S+$/.test(formData.email.trim())) {
      errors.email = "Enter a valid email";
    }
    if (!String(formData.mobileCountryCode || "").trim()) {
      errors.mobileCountryCode = "Mobile number is required";
    }
    if (!formData.role) {
      errors.role = "Role is required";
    }
    this.setState({ errors });
    return Object.keys(errors).length === 0;
  };
  handleSubmit = (e) => {
    e.preventDefault();
    if (!this.validate()) return;
    const { formData } = this.state;
    const payload = {
      fullName: formData.fullName?.trim(),
      email: formData.email?.trim(),
      mobileCountryCode: String(formData.mobileCountryCode || "").trim(),
      role: formData.role,
      gender: formData.gender,
    };
    if (formData.clinics) {
      payload.clinics = formData.clinics;
    }
    if (this.props.initialData && formData.status) {
      payload.status = formData.status;
    }
    this.props.onSubmit(payload);
  };
  render() {
    const { loading, initialData } = this.props;
    const { formData, errors } = this.state;
    const isEdit = !!initialData;
    return (
      <form onSubmit={this.handleSubmit}>
        <div className="card p-3">
          <h5>{isEdit ? "Edit Staff" : "Add Staff"}</h5>
          <div className="row">
            <div className="mb-3 col-md-6">
              <label>
                Full Name<span className="error">*</span>
              </label>
              <input
                type="text"
                name="fullName"
                className="form-control"
                value={formData.fullName}
                onChange={this.handleChange}
              />
              {errors.fullName && (
                <span className="error">{errors.fullName}</span>
              )}
            </div>
            <div className="mb-3 col-md-6">
              <label>
                Email<span className="error">*</span>
              </label>
              <input
                type="email"
                name="email"
                className="form-control"
                value={formData.email}
                onChange={this.handleChange}
              />
              {errors.email && <span className="error">{errors.email}</span>}
            </div>
          </div>
          <div className="row">
            <div className="mb-3 col-md-4">
              <label>
                Mobile Country Code<span className="error">*</span>
              </label>
              <input
                type="text"
                name="mobileCountryCode"
                className="form-control"
                value={formData.mobileCountryCode}
                onChange={this.handleChange}
              />
              {errors.mobileCountryCode && (
                <span className="error">{errors.mobileCountryCode}</span>
              )}
            </div>
            <div className="mb-3 col-md-4">
              <label>Clinic</label>
              <input
                type="text"
                name="clinics"
                className="form-control"
                value={formData.clinics}
                onChange={this.handleChange}
              />
            </div>
            {!isEdit && (
              <div className="mb-3 col-md-4">
                <label>
                  Role<span className="error">*</span>
                </label>
                <select
                  name="role"
                  className="form-control"
                  value={formData.role}
                  onChange={this.handleChange}
                >
                  <option value="STAFF">STAFF</option>
                  <option value="ADMIN">ADMIN</option>
                </select>
              </div>
            )}
            <div className="mb-3 col-md-4">
              <label>
                Gender<span className="error">*</span>
              </label>
              <select
                name="gender"
                className="form-control"
                value={formData.gender}
                onChange={this.handleChange}
              >
                <option value="MALE">MALE</option>
                <option value="FEMALE">FEMALE</option>
              </select>
            </div>
            {isEdit && (
              <div className="mb-3 col-md-4">
                <label>Status</label>
                <select
                  name="status"
                  className="form-control"
                  value={formData.status}
                  onChange={this.handleChange}
                >
                  <option value="ACTIVE">ACTIVE</option>
                  <option value="INACTIVE">INACTIVE</option>
                </select>
              </div>
            )}
          </div>
          <div className="d-flex justify-content-end">
            <Button
              type="submit"
              className="btn btn-primary"
              disabled={loading}
              text={loading ? "Saving..." : "Submit"}
            />
          </div>
        </div>
      </form>
    );
  }
}
export default withRouter(StaffForm);
